import { getDayOff } from "../../api/dayoff";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const useDayOff = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    const query = {
        page: Number(searchParams.get("page")) || 1,
        limit: Number(searchParams.get("limit")) || 10,
        startDate: searchParams.get("startDate") || firstDay.toISOString(),
        endDate: searchParams.get("endDate") || lastDay.toISOString(),
        search: searchParams.get("search") || ""
    };

    useEffect(() => {
        const url = new URL(window.location.href);
        if (url.searchParams.get("page") === null || url.searchParams.get("limit") === null) {
            setSearchParams({
                page: query.page.toString(),
                limit: query.limit.toString(),
            });
        }
    }, [query.page, query.limit, setSearchParams]);

    const setQuery = (newQuery: typeof query) => {
        const filteredQuery = Object.entries(newQuery)
            .filter(([_, value]) => value !== undefined && value !== null && value !== "")
            .reduce((acc, [key, value]) => ({
                ...acc,
                [key]: String(value)
            }), {});

        setSearchParams(new URLSearchParams(filteredQuery));
    };

    const { data, isLoading, isError } = useQuery({
        queryKey: ["day-off", query],
        queryFn: async () => {
            const response = await getDayOff(query);
            return response;
        },
        enabled: !!query.page && !!query.limit
    });

    return {
        data,
        isLoading,
        isError,
        setQuery,
        query
    };
};

export default useDayOff;